import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/'
import VueLazyload from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'
import VueCookie from 'vue-cookie'
import { userInfo } from './api'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import CcommonHeader from './components/header.vue'
import HeaderList from '/common/fabricHeader'
import HeaderListD from './components/header'
import commonHeaderChanelMenu from './components/headerChanelMenu.vue'
import commonHeaderChanelMenu2 from './components/headerChanelMenucommon.vue'
import CcommonUserLeft from './components/user_left.vue'

import CcommonFooter from './components/footer.vue'
import CcommonGoodsLeft from './components/design_goods_left.vue'

import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import '@/assets/iconfont/iconfont.css'

import { getStore } from '/utils/storage'
import { recordBehavor } from '/api/goods'
import VueContentPlaceholders from 'vue-content-placeholders'
import { setStore } from './utils/storage'
import JsonExcel from 'vue-json-excel'
// import './mock/index'
import axios from 'axios'

import i18n from '../i18n/i18n'
import VueI18n from 'vue-i18n'

Vue.use(VXETable)
Vue.use(VueI18n)
Vue.use(VueContentPlaceholders)
Vue.use(ElementUI)
Vue.use(infiniteScroll)
Vue.use(VueCookie)
Vue.use(VueLazyload, {
  // preLoad: 1.3,
  // error: 'dist/error.png',
  // 不显示首屏 loading 占位图
  // attempt: 1
})

Vue.prototype.$http = axios

Vue.component('global-header', () => import('@/components/header/header'))

Vue.component('common-header-chanel-menu-common', commonHeaderChanelMenu2)
Vue.component('common-header-chanel-menu', commonHeaderChanelMenu)
Vue.component('common-header', CcommonHeader)
Vue.component('header-list', HeaderList)
Vue.component('header-list-d', HeaderListD)
Vue.component('common-footer', CcommonFooter)
Vue.component('common-goods-left', CcommonGoodsLeft)
Vue.component('common-user-left', CcommonUserLeft)
Vue.component('downloadExcel', JsonExcel)
Vue.config.productionTip = false
// const whiteList = ['/home', '/goods', '/login', '/register', '/goodsDetails', '/chanels', '/search', '/refreshsearch', '/refreshgoods'] // 不需要登陆的页面
const whiteList = ['/login', '/nav', '/shareChanel', '/shareShapeDetails', '/fabricShow', '/wap/login', '/wap/modelShow', '/wap/designShow', '/wapErp/login', '/waperp/login']

const defaultTitle = 'W&S Products Centre'
router.beforeEach(function (to, from, next) {
  document.title = to.meta.title ? to.meta.title : defaultTitle

  let params = {
    params: {
      token: getStore('token')
    }
  }
  userInfo(params).then(res => {
    if (!res.data) { // 未登录
      if (whiteList.indexOf(to.path) !== -1) { // 白名单
        next()
      } else {
        if (to.path.toLowerCase().startsWith('/wap/')) {
          next(`/wap/login?redirect=${from.fullPath}`)
        } else if (to.path.toLowerCase().startsWith('/waperp/')) {
          next(`/wapErp/login?redirect=${from.fullPath}`)
        } else {
          next('/login')
        }
      }
    } else {
      let userInfoData = res.data
      // 从userInfoData中删除password字段和salt字段
      delete userInfoData.password
      delete userInfoData.salt
      store.commit('RECORD_USERINFO', { info: res.data })
      setStore('customerName', res.data.customerName)
      if (to.path.toLowerCase() === '/login') {
        next({ path: '/' })
      } else if (to.path.toLowerCase() === '/wap/login') {
        next({ path: '/wap/show' })
      } else if (to.path.toLowerCase() === '/waperp/login') {
        next({ path: '/wapErp/nav' })
      }
      next()
    }
  })
  // 记录访问日志
  // const commonTools = localStorage.getItem('commonTools') ? JSON.parse(localStorage.getItem('commonTools')) : []
  const routerData = to.fullPath
  const commonTools = routerData
  setStore('commonTools', JSON.stringify(commonTools))
  // routerData.router = {}
  // routerData.router.name = to.name
  // routerData.router.params = to.params
  // routerData.router.query = to.query
  // routerData.title = to.meta.pageTitle
  // routerData.name = to.name

  // if (commonTools.indexOf(routerData) !== -1) {
  //   commonTools.splice(0, 0, routerData)
  //   setStore('commonTools', JSON.stringify(commonTools))
  // }

  let actionStr = routerData
  let searchKeystr = ''
  let visitedProductsstr = ''

  // 获取行为类型 默认1
  let typestr = localStorage.getItem('behavorType') ? localStorage.getItem('behavorType') : 1
  if (routerData.lastIndexOf('type=') !== -1) {
    typestr = parseInt(routerData.substring(routerData.lastIndexOf('type=') + 5, routerData.lastIndexOf('type=') + 7))
    setStore('behavorType', typestr) // 存到本地
  }

  // 查找的key
  searchKeystr = localStorage.getItem('searchKey') ? localStorage.getItem('searchKey') : ''
  if (routerData.lastIndexOf('cid=') !== -1) {
    searchKeystr = routerData.substring(routerData.lastIndexOf('cid=') + 4, routerData.length)
    setStore('searchKey', searchKeystr) // 存到本地
  }
  // else {
  //   removeStore('searchKey')
  // }

  // 商品
  // visitedProductsstr = localStorage.getItem('visitedProduct') ? localStorage.getItem('visitedProduct') : ''
  if (routerData.lastIndexOf('productId=') !== -1) {
    visitedProductsstr = routerData.substring(routerData.lastIndexOf('productId=') + 10, routerData.lastIndexOf('productId=') + 42)
    // setStore('visitedProduct', visitedProductsstr) // 存到本地
  }

  let csName = getStore('customerName') !== null ? getStore('customerName') : ''
  recordBehavor({
    customerId: getStore('userId'),
    customerName: csName,
    country: '',
    remainTime: 0,
    action: actionStr,
    searchKey: searchKeystr,
    visitedProducts: visitedProductsstr,
    time: '',
    type: typestr
  }).then(res => {
    if (res.success === true) {
      // this.consultId = res.result
      // this.message_succed('succed!')
      console.log('用户行为记录成功' + actionStr)
      actionStr = ''
      searchKeystr = ''
      visitedProductsstr = ''
    } else {
      console.log('用户行为记录失败' + actionStr)
    }
  })
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js